var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('keep-alive',[(_vm.$route.meta.keepalive)?_c('router-view'):_vm._e()],1),_vm._v(" "),(!_vm.$route.meta.keepalive)?_c('router-view'):_vm._e(),_vm._v(" "),(_vm.isGroupRoute)?[_c('group-wx-share'),_vm._v(" "),_c('group-login'),_vm._v(" "),_c('group-go-index')]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6657e8fe","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 